import { useEffect } from "react";

import { useAppDispatch } from "Store/hooks";

import { resetSetupOptionsConfig } from "../setupOptions.slice";

export const useResetSetupOptionsConfig = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetSetupOptionsConfig());
  }, [dispatch]);
};
